module.exports = __webpack_public_path__ + "img/mapbox-compass-dark.9f65958c.svg";